import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";
export const metadata: FigureMetadata = {
  id: "PARITYCOUNT",
  title: defineMessage({
    id: "fig.equity.PARITYCOUNT.title",
    defaultMessage: `Percentage of countries that have achieved gender parity in the gross enrolment ratio, by education level`,
  }),
  caption: defineMessage({
    id: "fig.equity.PARITYCOUNT.caption",
    defaultMessage: `Many countries have yet to achieve parity in secondary education`,
  }),
  source: defineMessage({
    id: "fig.equity.PARITYCOUNT.source",
    defaultMessage: `GEM Report team analysis based on UIS data`,
  }),
};
